import {login, logout} from 'core/api/study_reviewer'
import * as jwt_decode from 'jwt-decode'
import {startSubmit, stopSubmit} from 'redux-form'
import {all, call, put, takeLatest} from 'redux-saga/effects'
import {IActionLoginRequest, IActionLogoutRequest, tokenSet} from './actions'
import {LOGIN_REQUEST, LOGOUT_REQUEST} from './actionTypes'
import safeSessionStorage from 'core/store/safe-session-storage'

/**
 * Dependencies needed for this saga
 */
export interface IDependencies {
  selectToken: () => void
  clearState: () => void
}

export function* loginRequest(action: IActionLoginRequest) {
  yield put(startSubmit(action.form))
  try {
    const response = yield call(login, action.payload)
    const data = response.data
    if (response.status === 200) {
      const { token } = data
      // Use jwt-decode to extract the role from the token
      const decodedToken = jwt_decode(token) as any
      const { role } = decodedToken
      yield put(tokenSet({ token, role }))
      yield put(stopSubmit(action.form))
    }

  } catch (e) {
    console.log('Error', e)
    if (e.response.status === 401) {
      const error = e.response.data.message
      yield put(stopSubmit(action.form, {_error: error}))
    }
  }
}

export function* logoutRequestSaga(dependencies: IDependencies, action: IActionLogoutRequest) {
  const token = yield call(dependencies.selectToken);
  try {
    yield call(logout, token);
  } catch (e) {
    // Swallow error. The credentials may have expired by this point which would result in a 401.
    // But even if the request here fails, the token will expire eventually anyway.
  }
  yield call(() => safeSessionStorage.clear());

  yield call(dependencies.clearState);
}

function* loginSaga(dependencies: IDependencies) {
  yield all([
    takeLatest(LOGIN_REQUEST, loginRequest),
    takeLatest(LOGOUT_REQUEST, logoutRequestSaga, dependencies),
  ])
}

export default loginSaga



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/store/login/saga.ts